import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import { Divider, Typography } from '@mui/material';
import { CheckCircleOutlined as CompletedIcon } from '@mui/icons-material';
const Step = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(2),
    cursor: 'default',
}));
const LabelContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    // alignItems: 'center',
    flexDirection: 'column',
}));
const Label = styled('div')(({ theme, isActive }) => ({
    display: 'flex',
    // alignItems: 'center',
    flexDirection: 'column',
    color: isActive ? theme.palette.primary.main : undefined,
}));
const Detail = styled(Typography)(({ theme }) => ({
    // marginLeft: theme.spacing(2),
    fontSize: 14,
    color: theme.palette.grey[600],
    // '&::before': {
    //   content: '"-"',
    //   marginRight: theme.spacing(0.5),
    // },
}));
const CompletedIconContainer = styled('div')(({ theme }) => ({
    height: 24,
    justifySelf: 'flex-end',
    color: theme.palette.success.main,
}));
const Steps = ({ steps, step = 0, handleStepClick }) => {
    return (_jsx(_Fragment, { children: steps.map((i, index) => (_jsxs("div", { children: [_jsxs(Step, Object.assign({ sx: index < step
                        ? {
                            cursor: 'pointer',
                            '&:hover': {
                                color: 'primary.light',
                            },
                        }
                        : {}, onClick: () => (index < step ? handleStepClick(index) : null) }, { children: [_jsxs(LabelContainer, { children: [_jsx(Label, Object.assign({ isActive: index === step, color: "textSecondary" }, { children: i.label })), i.detail && _jsx(Detail, { children: i.detail })] }), index < step && (_jsx(CompletedIconContainer, { children: _jsx(CompletedIcon, {}) }))] })), _jsx(Divider, {})] }, i.label))) }));
};
export default Steps;
//# sourceMappingURL=steps.js.map